@let summary = countSummary();
<a
  class="btn p-1 lh-1 border-0 position-relative"
  routerLink="/notifications"
  [pTooltip]="'AgenticCX::Notification:Title' | abpLocalization"
  tooltipPosition="left">
  <i class="fas fa-bell lpx-menu-item-icon notification-bell-icon" aria-hidden="true"></i>
  @if (summary.unread > 0) {
    <p-badge
      class="notification-bell-badge"
      [value]="badgeValue(summary.unread)"
      severity="danger"
      badgeSize="small"
      [@badgePop]="popTrigger()" />
  }
</a>
